
/* @ngInject */
export default function hpDownloadLink($http, $window, HPConfig) {
    return {
        restrict: 'A',
        link(scope, element) {
            element.on('click', (e) => {
                e.preventDefault();
                const urlSplit = element[0].href.split('?');
                let downloadUrl = element[0].href;
                if (urlSplit[0].indexOf('DocumentManagement/DownloadDocument') >= 0) {
                    downloadUrl = `${HPConfig.heroProApi}DocumentManagement/DownloadDocumentUrl?${urlSplit[1]}`;
                } else if (urlSplit[0].indexOf('Pipeline/SpreadSheet') >= 0) {
                    downloadUrl = `${HPConfig.heroProApi}Pipeline/SpreadSheetUrl`;
                } else if (urlSplit[0].indexOf('ELearning/UserCertificate') >= 0) {
                    downloadUrl = `${HPConfig.heroProApi}ELearning/UserCertificateUrl`;
                }
                $http.get(downloadUrl).then((result) => {
                    $window.location = result.data;
                });
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpDownloadLink.directive.js